/*
 * OutIn motion helpers (assets/outin-motion.js)
 * ---------------------------------------------------------------------------
 * CSS handles almost everything (see outin-motion.css). This file only covers
 * the two things CSS cannot detect: the product image or price changing when a
 * variant is selected.
 *
 *  - Uses the Web Animations API (no classes, no forced reflow, nothing left
 *    behind in the DOM) and only animates opacity/transform.
 *  - Does nothing for visitors who prefer reduced motion.
 *  - Never touches product data, cart, Trustoo, ratings or installments: it
 *    only *observes* the existing nodes and plays a short animation on them.
 */
(function () {
  'use strict';
  if (window.__oxMotion) return;
  window.__oxMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('MutationObserver' in window) || typeof Element.prototype.animate !== 'function') return;

  var EASE = 'cubic-bezier(.22,.7,.2,1)';

  function motionAllowed() {
    return !(reduce && reduce.matches);
  }

  /* ---- main product image: soft fade/settle when its source changes ---- */
  function playImage(img) {
    if (!motionAllowed() || !img || !img.isConnected) return;
    img.animate(
      [{ opacity: 0, transform: 'scale(1.02)' }, { opacity: 1, transform: 'none' }],
      { duration: 360, easing: EASE }
    );
  }
  function onImageChange(img) {
    if (img.complete && img.naturalWidth) playImage(img);
    else img.addEventListener('load', function () { playImage(img); }, { once: true });
  }

  var IMAGE_ROOTS = '.mino-gallery__main, [data-fino-gallery-main]';
  function watchImages(scope) {
    (scope || document).querySelectorAll(IMAGE_ROOTS).forEach(function (root) {
      if (root.__oxImg) return;
      root.__oxImg = true;
      new MutationObserver(function (list) {
        var seen = [];
        list.forEach(function (m) {
          var t = m.target;
          if (m.type === 'attributes' && t.tagName === 'IMG' && seen.indexOf(t) < 0) seen.push(t);
          if (m.type === 'childList') {
            m.addedNodes.forEach(function (n) {
              if (n.tagName === 'IMG' && seen.indexOf(n) < 0) seen.push(n);
            });
          }
        });
        seen.forEach(onImageChange);
      }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
    });
  }

  /* ---- price: quick fade/settle when the text actually changes ---- */
  var PRICE_NODES = '[data-fino-price], [data-mino-price-now], [data-fino-sticky-price]';
  function watchPrices(scope) {
    (scope || document).querySelectorAll(PRICE_NODES).forEach(function (el) {
      if (el.__oxPrice) return;
      el.__oxPrice = true;
      var last = el.textContent;
      new MutationObserver(function () {
        var now = el.textContent;
        if (now === last) return;
        last = now;
        if (!motionAllowed()) return;
        el.animate(
          [{ opacity: 0.25, transform: 'translate3d(0,3px,0)' }, { opacity: 1, transform: 'none' }],
          { duration: 260, easing: EASE }
        );
      }).observe(el, { subtree: true, childList: true, characterData: true });
    });
  }

  function init(scope) {
    watchImages(scope);
    watchPrices(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
